<template>
  <div>
    <van-nav-bar :right-text="username" left-arrow left-text="返回" title="整件作业" @click-left="onClickLeft" @click-right="goIndex()"/>
    <van-field v-model="detail.location.no" label="出库货位" name="出库货位" readonly/>
    <van-field v-model="detail.orderType.name" label="订单类型" name="订单类型" readonly/>
    <van-field v-model="detail.order.no" label="单据编号" name="单据编号" readonly/>
    <van-field v-model="detail.item.no" label="商品编号" name="商品编号" readonly/>
    <van-field v-model="detail.item.name" label="通用名称" name="通用名称" readonly/>
    <van-field v-model="detail.pack.specification" label="规格" name="规格" readonly/>
    <van-field v-model="detail.pack.uom" label="计量单位" name="计量单位" readonly/>
    <van-field v-model="detail.pack.factor" label="包装数" name="包装数" readonly/>
    <van-field v-model="detail.lot.no" label="批号" name="批号" readonly/>
    <van-field v-model="detail.lot.productionDate" label="生产日期" name="生产日期" readonly/>
    <van-field v-model="detail.lot.validUntil" label="有效期" name="有效期" readonly/>
    <van-field v-model="detail.lot.manufacturer" label="生产厂商" name="生产厂商" readonly/>
    <van-field v-model="detail.lot.producingArea" label="产地" name="产地" readonly/>
    <van-field v-model="detail.lot.approvalNo" label="批准文号" name="批准文号" readonly/>
    <van-row>
      <van-col span="8">
        <van-cell center title="监管">
          <van-switch slot="right-icon" v-model="detail.command.supervised" active-color="#07c160" disabled inactive-color="#dcdee0" size="24"/>
        </van-cell>
      </van-col>
      <van-col span="8">
        <van-cell center title="易碎">
          <van-switch slot="right-icon" v-model="detail.item.fragile" active-color="#07c160" disabled inactive-color="#dcdee0" size="24"/>
        </van-cell>
      </van-col>
      <van-col span="8">
        <van-cell center title="追加">
          <van-switch slot="right-icon" v-model="detail.appending" active-color="#07c160" inactive-color="#dcdee0" size="24"/>
        </van-cell>
      </van-col>
    </van-row>
    <van-row>
      <van-col span="12">
        <van-field v-model="detail.command.plannedQuantity" label="计划数量" name="计划数量" readonly/>
      </van-col>
      <van-col span="12">
        <van-field v-model="detail.numberOfCase" label="计划件数" name="计划件数" readonly/>
      </van-col>
    </van-row>
    <van-row>
      <van-col span="12">
        <van-field v-model="detail.command.actualQuantity" label="实际数量" name="实际数量" readonly/>
      </van-col>
      <van-col span="12">
        <van-field v-model="detail.numberOfCase2" clearable error label="实际件数" name="实际件数" type="number"/>
      </van-col>
    </van-row>
    <van-tabbar>
      <van-tabbar-item>
        <van-row gutter="20">
          <van-col span="12">
            <van-button block round style="margin: 8px;" type="info" @click="supervise">监管</van-button>
          </van-col>
          <van-col span="12">
            <van-button :loading="loading" block round style="margin: 8px;" type="primary" @click="confirm">确认</van-button>
          </van-col>
        </van-row>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
import api from '@/api'
import { findOne, post } from '@/api/Api'
import { Toast } from 'vant'
import { getUser } from '@/pdaView/utils'
import { ShippingFactoryView } from '@/api/dto/view/ShippingFactoryView'

export default {
  data() {
    return {
      loading: false,
      username: getUser().name,
      detail: new ShippingFactoryView()
    }
  },
  activated: function() {
    this.refresh()
  },
  methods: {
    goIndex() {
      this.$router.push({ name: 'PdaIndex' })
    },
    onClickLeft() {
      this.$router.push({ name: this.$route.params.parent })
    },
    refresh() {
      this.loading = true
      const args = {
        'pickingOrder.id': this.$route.params.pickingOrderId
      }
      findOne('pickingTaskDetailFactory', args).then(res => {
        if (res.success && res.result) {
          this.detail = {
            ...res.result,
            numberOfCase: Math.ceil(res.result.command.plannedQuantity / res.result.pack.factor),
            numberOfCase2: Math.ceil(res.result.command.actualQuantity / res.result.pack.factor),
            appending: res.result.command.appendageSign === 1
          }
        } else {
          this.onClickLeft()
        }
      }).finally(() => this.loading = false)
    },
    confirm() {
      if (!this.detail) {
        Toast('无数据确认！')
        return
      }
      if (this.detail.numberOfCase2 > this.detail.numberOfCase) {
        Toast('实际件数不能大于计划件数！')
        return
      }
      this.loading = true
      const args = {
        'pickingOrder.id': this.detail.pickingOrder.id,
        commandGroup: this.detail.command.commandGroup
      }
      if (this.detail.numberOfCase > this.detail.numberOfCase2) {
        args.actualQuantity = this.detail.numberOfCase2 * this.detail.pack.factor
        args.appendageSign = this.detail.appending === true ? 1 : 3
      }
      post(api.pickingConfirm, { type: 'shipmentCommandConfirmer' }, args).then(res => {
        if (res.success) {
          Toast('确认成功！')
          this.refresh()
        }
      }).finally(() => this.loading = false)
    },
    supervise() {
      if (this.detail.command.supervised) {
        this.$router.push({ name: 'SupervisionCode', params: { parent: 'CasePicking', command: this.detail.command, pack: this.detail.pack } })
      }
    }
  }
}
</script>